const margin = { top: 20, right: 20, bottom: 30, left: 40 }

export {
  margin
}
